<template>
  <Head :title="__('Log In')"/>

  <div>
    <jet-authentication-card>

<!--      <div class="grid grid-cols-2 gap-4">-->
<!--        <a href="#"-->
<!--           class="flex w-full items-center justify-center gap-3 rounded-md bg-[#1D9BF0] px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1D9BF0]">-->
<!--          <svg class="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">-->
<!--            <path-->
<!--                d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"/>-->
<!--          </svg>-->
<!--          <span class="text-sm font-semibold leading-6">Twitter</span>-->
<!--        </a>-->

<!--        <a href="#"-->
<!--           class="flex w-full items-center justify-center gap-3 rounded-md bg-[#24292F] px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#24292F]">-->
<!--          <svg class="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">-->
<!--            <path fill-rule="evenodd"-->
<!--                  d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"-->
<!--                  clip-rule="evenodd"/>-->
<!--          </svg>-->
<!--          <span class="text-sm font-semibold leading-6">GitHub</span>-->
<!--        </a>-->
<!--      </div>-->

<!--      <div class="relative mt-10 my-3">-->
<!--        <div class="absolute inset-0 flex items-center" aria-hidden="true">-->
<!--          <div class="w-full border-t border-gray-200" />-->
<!--        </div>-->
<!--        <div class="relative flex justify-center text-sm font-medium leading-6">-->
<!--          <span class="bg-white px-6 text-gray-900">{{ __('Or continue with') }}</span>-->
<!--        </div>-->
<!--      </div>-->

      <template #logo>
        <jet-authentication-card-logo/>
      </template>

      <jet-validation-errors class="mb-4"/>

      <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <form @submit.prevent="submit">
        <div>
          <jet-label for="email" :value="__('E-Mail')"/>
          <jet-input :icon="icon.email" id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus/>
        </div>

        <div class="mt-4">
          <jet-label for="password" :value="__('Password')"/>
          <jet-input :icon="icon.password" id="password" type="password" class="mt-1 block w-full" v-model="form.password" required
                     autocomplete="current-password"/>
        </div>

        <div class="block mt-4">
          <label class="flex items-center">
            <jet-checkbox name="remember" v-model="form.remember"/>
            <span class="ml-2 text-sm text-gray-600">{{ __('Remember me') }}</span>
          </label>
        </div>

        <div class="flex items-center justify-end mt-4">
          <inertia-link :href="route('password.request')"
                class="underline text-sm text-gray-600 hover:text-gray-900">
            {{ __('Forgot your password?') }}
          </inertia-link>
          <jet-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
            {{ __('Login') }}
          </jet-button>
        </div>

      </form>

      <p class="mt-4 text-center text-sm leading-5 text-gray-600 max-w border-t border-gray-200 pt-4">
        {{ __('Don\'t have an account?') }}
        <inertia-link :href="route('register')" class="text-primary hover:text-primary-600">
          {{ __('Register') }}
        </inertia-link>
      </p>

    </jet-authentication-card>
  </div>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import {Head} from '@inertiajs/inertia-vue3';
import GuestLayout from "@/Layouts/GuestLayout";
import {defineComponent, h} from "vue";

export default {
  components: {
    GuestLayout,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
    Head
  },

  props: {
    canResetPassword: Boolean,
    status: String
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false
      }),
      icon: {
        email: defineComponent({
          render() {
            return h('svg', {
              width: '24',
              height: '24',
              viewBox: '0 0 24 24',
              fill: 'none',
              xmlns: 'http://www.w3.org/2000/svg'
            }, [
              h('path', {
                d: 'M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z',
                stroke: 'currentColor',
                'stroke-width': '2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round'
              })
            ]);
          }
        }),
        password: defineComponent({
          render() {
            return h('svg', {
              width: '24',
              height: '24',
              viewBox: '0 0 24 24',
              fill: 'none',
              xmlns: 'http://www.w3.org/2000/svg'
            }, [
              h('path', {
                d: 'M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z',
                stroke: 'currentColor',
                'stroke-width': '2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round'
              })
            ]);
          }
        })
      }
    }
  },

  methods: {
    submit() {
      this.form
          .transform(data => ({
            ...data,
            remember: this.form.remember ? 'on' : ''
          }))
          .post(this.route('login'), {
            onFinish: () => this.form.reset('password'),
          })
    }
  }
}
</script>
